export const COGNITO = {
    REGION: "eu-west-2",
    USER_POOL_ID: "eu-west-2_DxMW7OHZo",
    APP_CLIENT_ID: "190isl7jbjlhfmpj1km4kd4lsh",
  };